import { render, staticRenderFns } from "./BoardsId.vue?vue&type=template&id=2a109854&"
import script from "./BoardsId.vue?vue&type=script&lang=js&"
export * from "./BoardsId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports